import { SvgIcon } from "@mui/material"

import { ReactComponent as City } from "./City.svg"

export const CityIcon = (props) => {
    return (
        <SvgIcon component={City} {...props} inheritViewBox />
    )
}